import script from "./TgAppGateOut.vue?vue&type=script&setup=true&lang=js"
export * from "./TgAppGateOut.vue?vue&type=script&setup=true&lang=js"

import "./TgAppGateOut.vue?vue&type=style&index=0&id=c94e5f02&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c94e5f02"]])

export default __exports__